export interface AuthUser {
    email: string;
    name: string;
    userId: string;
}

export type AuthPrompt =
    | 'login'
    | 'mfaCode'
    | 'newPassword'
    | 'forgotPassword'
    | 'confirmReset';

export interface LoginResult {
    success: boolean;
    prompt?: AuthPrompt;
    challengeName?: string;
    message?: string;
}

export interface PendingChallenge {
    challengeName: string;
    username: string;
    /** Atributos que Cognito exige completar junto con la nueva contraseña
     *  (NEW_PASSWORD_REQUIRED). Ej: ["name", "family_name"]. */
    missingAttributes?: string[];
}

export interface PasswordRule {
    label: string;
    passed: boolean;
}

export interface PasswordPolicyResult {
    valid: boolean;
    rules: PasswordRule[];
}

export const SESSION_KEY = 'clam_session';
export const TOKEN_STORAGE_KEYS = ['idToken', 'accessToken', 'refreshToken', 'userId', 'userEmail'] as const;
